const saveCookie = (appData) => ({
	type: "SAVE_COOKIE",
	appData,
});

const setConfigFile = (config) => ({
	type: "SET_CONFIG",
	config,
});

const setLetterTemplatesSettings = (letterTemplatesSettings) => ({
	type: "SET_LETTER_TEMPLATES_SETTINGS",
	letterTemplatesSettings,
});

const setLang = (lang) => ({
	type: "SET_CURRENT_LANGUAGE",
	lang,
});

const setCookiePermission = (cookiePermission) => ({
	type: "SET_COOKIE_PERMISSION",
	cookiePermission,
});

const setLoading = (isLoading) => ({
	type: "SET_LOADING",
	isLoading,
});

const setError = (errCode) => ({
	type: "SET_ERROR",
	errCode,
});

const setNotFound = (isNotFound) => ({
	type: "SET_NOTFOUND",
	isNotFound,
});

const setModalInfo = (info) => ({
	type: "SET_MODAL_INFO", 
	info,
});

const setLastLettersURL = (url) => ({
	type: "SET_LAST_LETTERS_URL",
	url,
});

const setInstanceConfiguration = (config) => ({
	type: "SET_INSTANCE_CONFIGURATION",
	config,
});

export const appActions = {
	saveCookie,
	setConfigFile,
	setLetterTemplatesSettings,
	setLang,
	setLoading,
	setError,
	setNotFound,
	setCookiePermission,
	setModalInfo,
	setLastLettersURL,
	setInstanceConfiguration,
};